
import React, { useState, useEffect } from "react";
import { Protected } from "@/components/layout/Protected";
import { Box, Button, Card, CardActions, CardContent, Container, Divider, Grid, Tooltip, Typography } from "@mui/material";
import { Popup } from '../Editor/components/Popup/Popup';
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, createTheme, ThemeProvider } from '@mui/material';
import { esES } from '@mui/material/locale';
import DeleteIcon from '@mui/icons-material/Delete';
import { PencilIcon } from "@toolbox/constants/icons";
import EditIcon from '@mui/icons-material/Edit';
import { salas } from '../../service/services/Salas.service';
import { Loading } from '../../components/common/Loading/Loading';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { ModalReservas } from "./../Reservas/components/ModalReservas";
// import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { Snackbar, Alert } from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SettingsIcon from '@mui/icons-material/Settings';
import { AddSala } from "../Salas/components/AddSala";
import { AddMesa } from "../Salas/components/AddMesa";
import { ConfigMesa } from "../Salas/components/ConfigMesa";
import { CodigoQR } from "../Salas/components/CodigoQR";
import { cajas } from "@/service/services/Cajas.service";
import { AddCaja } from "./AddCaja";
import { sucursalesService } from "@/service/services/Sucursales.service";

export const CajasMantenedor: React.FC<any> = (props:any): JSX.Element => {

    const [popUp, setPopUp] = React.useState<String>('');
    const [openPopup, setOpenPopup] = React.useState(false);
    const [allCajas, setCajas] = React.useState([]);
    const [sucursales, setSucursales] = React.useState([]);
    const [loadData,setLoadData] = React.useState<boolean>(false);
    const [selectCaja, setSelectCaja] = React.useState<any>('');
    const [textSearch, setTextSearch] = useState<string>("");
    const [filter, setFilter] = useState<Array<any>>([]);
    // eslint-disable-next-line
   const [dataModalSala, setDataModalCaja] = useState<any>(false);

   const [snackBarConfig, setSnackBarConfig] = React.useState<any>({
    open: false,
    severity: 'error',
    message: 'Error',
    autoHideDuration: 3000,
    });


   React.useEffect(() => {
    async function fetch(){
        setLoadData(true);
        await cajas.cargarCajas().then((data)=>{
            setCajas(data.cajas);
            setLoadData(false);
        });
    }
    fetch();
    allSucursales();
    },// eslint-disable-next-line
    []);


   const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976D2' },
        },
    },
    esES,
    );

    const deleteCaja = async (id)=>{
        setLoadData(true);
        await cajas.deleteCaja(id);
        cargarCajas();
        setLoadData(false);
    }

    const cargarCajas = async ()=>{
        setLoadData(true);
        await cajas.cargarCajas().then((data)=>{
            setCajas(data.cajas || []);
            setLoadData(false);
        });
    }

    const allSucursales = async () => {
        setLoadData(true);
        await sucursalesService.listAllSucursales().then((data)=> {
setSucursales(data)
        })
    }


   return (
      <Protected>
          {loadData && <Loading/>}
          <Snackbar
            open={snackBarConfig.open}
            autoHideDuration={snackBarConfig.autoHideDuration}
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
            <Alert
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            severity={snackBarConfig.severity}
            variant="filled"
            >
            {snackBarConfig.message}
            </Alert>
        </Snackbar>
         <Container maxWidth='xl' sx={{ mt: 1, mb: 2 }}>
                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid item>
                        <Typography variant='h4' >Mantenedor de cajas</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant='outlined' style={{textTransform: "capitalize"}}
                        onClick={()=>{
                            setOpenPopup(true);
                            setDataModalCaja(false);
                            setPopUp('add');
                        }}
                        >Crear Caja</Button>
                    </Grid>
                </Grid>
                <Divider
                    sx={{ mt: 2 }} />
                <Grid container spacing={1} >
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: '20px' }} >
                        {allCajas.length ? `${allCajas.length} registros encontrados` : `0` && !loadData}
                        </Typography>
                    </Grid>
                </Grid>

                {loadData && allCajas.length === 0 &&
                     <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                     </Box>
                }

            <Grid >
                {allCajas.length !== 0 &&
                <Box sx={{Width: '100%', marginTop:'30px'}}>
                    <TableContainer component={Paper}>
                    <ThemeProvider theme={theme}>
                        <Table aria-label="simple table" size='small'>
                            <TableHead >
                            <TableRow sx={{ bgcolor:'#1976D2'}}>
                                    <TableCell sx={{ color: 'white' }} ><strong>N°</strong></TableCell>
                                    <TableCell sx={{ color: 'white' }} ><strong>Nombre Caja</strong></TableCell>
                                    <TableCell align='center' sx={{ color: 'white' }} ><strong>Sucursal</strong></TableCell>
                                    <TableCell align='center' sx={{ color: 'white' , minWidth:'8rem', maxWidth:'12rem'}}><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {allCajas.length !== 0 &&
                                    allCajas.map((item,index) => (
                                    <TableRow key={item.id}>
                                        <TableCell component="th" scope="row">
                                            {index+1}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {item.nombre.charAt(0).toUpperCase() + item.nombre.slice(1).toLowerCase()}
                                        </TableCell>
                                        <TableCell align='center' component="th" scope="row">
                                            {item.sucursal_name}
                                        </TableCell>
                                    <TableCell align='center'>
                                        <Button color="error"
                                            onClick={()=>{deleteCaja(item.id)}}
                                        >
                                            <DeleteIcon />
                                        </Button>
                                        <Button
                                            onClick={() =>  {
                                                setOpenPopup(true);
                                                setPopUp('edit');
                                                setSelectCaja(item);
                                            }}
                                        >
                                            <PencilIcon />
                                        </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </ThemeProvider>
                    </TableContainer>
                </Box>
                }
                {!loadData && allCajas.length === 0 &&
                    <Grid container justifyContent="center">
                        <Box sx={{marginTop: '50px'}}>
                            <Grid container justifyContent="center"> <ContentPasteOffIcon className="iconocarrito"/></Grid>
                            <Box sx={{Width: '100%', marginBottom:'30px', textAlign:'center'}}>No hay cajas</Box>
                        </Box>
                    </Grid>
                }
            </Grid>
         </Container>

         {popUp === 'add' &&
         <Popup
            largo="sm"
            title = 'Crear Caja'
            openPopup = {openPopup}
            setOpenPopup = {setOpenPopup}
        >
            <AddCaja
                closeModal = {() => setOpenPopup(false)}
                onListCaja = {cargarCajas}
                sucursales = {sucursales}
            />
        </Popup>
         }

        {popUp === 'edit' &&
         <Popup
            largo="sm"
            title = 'Editar Caja'
            openPopup = {openPopup}
            setOpenPopup = {setOpenPopup}
        >
            <AddCaja
                caja={selectCaja}
                closeModal = {() => setOpenPopup(false)}
                onListCaja = {cargarCajas}
                sucursales = {sucursales}
            />
        </Popup>
         }
      </Protected>
   )

}
